import React, { useRef } from 'react';
import { DateRangePicker, DateRangePickerProps as RSDateRangePickerProps } from 'rsuite';
import { FieldProps } from 'formik';
import dayjs from 'dayjs';
import { TypeAttributes } from 'rsuite/lib/@types/common';
import { FULL_DATE } from '@/constants/dateFormat';

export interface DateRangePickerProps extends Omit<RSDateRangePickerProps, 'form'>, FieldProps {}

const BicesterDateRangePicker = ({
  field,
  form,
  className,
  style,
  format = FULL_DATE,
  placement,
  placeholder = ' ',
  onClean,
  ...props
}: {
  className?: string;
  style?: any;
  format?: string;
  placement?: TypeAttributes.Placement;
  placeholder?: React.ReactNode;
  onClean?: (event: React.SyntheticEvent<HTMLElement, Event>) => void;
  [rest: string]: any;
} & DateRangePickerProps) => {
  const rangeRef = useRef(null);
  return (
    <DateRangePicker
      ref={rangeRef}
      className={className}
      style={style}
      format={format}
      placement={placement}
      placeholder={placeholder}
      value={
        field.value && field.value?.length === 2
          ? [
              typeof field.value[0] === 'string' ? new Date(field.value[0]) : field.value[0],
              typeof field.value[1] === 'string' ? new Date(field.value[1]) : field.value[1],
            ]
          : []
      }
      // onChange={(value, event) => {
      //   const startDate = dayjs(value[0]).format(format);
      //   const endDate = dayjs(value[1]).format(format);
      //   form.setFieldValue(field.name, startDate && endDate ? [startDate, endDate] : []);
      //   field.onChange(event);
      // }}
      /**
       * 选中两个日期后直接自动确认选中值并关闭日历
       * - 不适合用onTap实现，所以css隐藏确定按钮
       * - .rs-picker-daterange-panel > .rs-picker-toolbar { display: none; }
       */
      onSelect={(date, event) => {
        const selectedRange = rangeRef?.current?.state?.selectValue || [];
        if (selectedRange.length === 2) {
          const startDate = dayjs(selectedRange[0]).format(format);
          const endDate = dayjs(selectedRange[1]).format(format);
          form.setFieldValue(field.name, [startDate, endDate]);
          rangeRef?.current?.close();
        }
      }}
      onClean={(event) => {
        form.setFieldValue(field.name, []);
        onClean && onClean(event);
      }}
      showOneCalendar
      {...props}
    />
  );
};

export default BicesterDateRangePicker;
